import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment'
import { Globals } from "./global";
import { AgoraConfigService } from "src/AgoraConfigService";

@Injectable({
    providedIn: 'root'
  })
export class SettingsService {

    httpHeaders: any;
  agoraConfigObject: any;

    constructor(private http: HttpClient,public globals: Globals, private agoraConfig: AgoraConfigService) {
      this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
      this.httpHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
        .set("Access-Control-Allow-Headers", "*")
        .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
    }

    fetchSettingsInfoList(orgCode: any) {
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.codelistOrg}fetchSettingsInfo/`+orgCode, { headers: this.httpHeaders });
      }
    
      saveSettingsInfo(request:any){
        
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.codelistOrg}saveSettingsInfo`,request, {headers: this.httpHeaders})
      }
    
      fetchSettingsListSource(reload: any) {
        return new Promise(async(resolve, reject) => {
          if (reload == "Y" || this.globals.settingValuesList == undefined) {
             await this.fetchSettingsInfoList(localStorage.getItem('orgCode')).subscribe((result: any) => {
              
              this.globals.settingValuesList = result;
              
              resolve(this.globals.settingValuesList);
            });
          } 
          else {
            resolve(this.globals.settingValuesList);
          }
        });
    
      }

}
